export enum LocalStorageKeys {
    HAS_COMPLETED_INTRODUCTORY_STEPS = 'hasCompletedIntroductorySteps'
}
